import { CalcVariants, Difficulty } from '../types';

export function random(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const difficulties: Record<
  CalcVariants,
  Record<Difficulty, Record<'min' | 'max', number>>
> = {
  plus: {
    easy: { min: 1, max: 100 },
    medium: { min: 1, max: 1000 },
    hard: { min: 1, max: 10000 },
  },
  minus: {
    easy: { min: 1, max: 100 },
    medium: { min: 1, max: 1000 },
    hard: { min: 1, max: 10000 },
  },
  times: {
    easy: { min: 1, max: 10 },
    medium: { min: 1, max: 50 },
    hard: { min: 1, max: 100 },
  },
  divide: {
    easy: { min: 1, max: 100 },
    medium: { min: 1, max: 250 },
    hard: { min: 1, max: 500 },
  },
};

export function isPrime(num: number) {
  for (var i = 2; i < num; i++) if (num % i === 0) return false;
  return num > 1;
}
